<template>
  <a-layout>
    <a-layout-content :style="{ backgroundColor: 'white' }">
      <div class="vd-table-tools vd-left">
        <a-button type="primary" icon="plus" @click="add">新增成员 </a-button>
        <a-button icon="tool" @click="batchQrCode">
          批量生成二维码
        </a-button>
        <a-button icon="search" @click="beforeDownload">
          预览导出二维码
        </a-button>
      </div>
      <a-table
        :data-source="tableData"
        row-key="id"
        :pagination="pagination"
        :loading="loading"
        @change="pageChange"
      >
        <a-table-column title="ID" data-index="id" />
        <a-table-column title="姓名" data-index="name" />
        <a-table-column title="编号" data-index="code" />

        <a-table-column title="任务量" data-index="task">
          <template slot-scope="text, record">
            {{ record.complete }} / {{ text }}
            <a-progress :percent="record.percent" status="active" />
          </template>
        </a-table-column>
        <a-table-column title="推广二维码" data-index="qrcode">
          <template slot-scope="text">
            <a-avatar
              :src="$CheckUtil.CheckEmpty(text) ? text : '#'"
              shape="square"
              :size="84"
              >QrCode
            </a-avatar>
          </template>
        </a-table-column>
        <a-table-column title="类型" data-index="type">
          <template slot-scope="text">
            {{ text === 1 ? "员工" : "兼职" }}
          </template>
        </a-table-column>
        <a-table-column align="center" title="操作" data-index="operation">
          <template slot-scope="text, record">
            <span>
              <a-tag color="blue" @click="edit(record)"> 编辑</a-tag>
              <a-tag color="cyan" @click="createQr(record)">
                生成推广二维码</a-tag
              >
            </span>
          </template>
        </a-table-column>
      </a-table>

      <a-modal
        :visible="visible"
        :title="modalType === false ? '添加成员' : '修改成员信息'"
        ok-text="确认"
        cancel-text="取消"
        @ok="Confirm"
        @cancel="Cancel"
        :confirm-loading="confirmLoading"
      >
        <a-form-model :form="form" layout="horizontal">
          <a-form-model-item label="姓名" :label-col="{ span: 4 }">
            <a-input
              class="vd-input-s"
              v-model="form.name"
              placeholder="姓名"
            />
          </a-form-model-item>
          <a-form-model-item label="工号/编号" :label-col="{ span: 4 }">
            <a-input
              class="vd-input-s"
              v-model="form.code"
              placeholder="工号/编号"
            />
          </a-form-model-item>
          <a-form-model-item label="类型" :label-col="{ span: 4 }">
            <a-select style="width: 216px" v-model="form.type">
              <a-select-option :key="1" :value="0">
                员工
              </a-select-option>
              <a-select-option :key="2" :value="1">
                兼职
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="任务量" :label-col="{ span: 4 }">
            <a-input-number
              class="vd-input-xs"
              :value="form.task"
              :min="1"
              :max="1000"
              :default-value="999"
              @change="
                (e) => {
                  checkNum(e);
                }
              "
              type="number"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <!-- 打印预览页面 -->
      <a-modal
        :visible="preview"
        :width="A_4.w + 100"
        ok-text="下载"
        cancel-text="关闭预览"
        @ok="download"
        @cancel="cancelPreview"
        title="打印预览 A4"
      >
        <div class="vd-table-tools vd-left">
          <a-button type="primary" @click="download">下载</a-button>
        </div>
        <div id="preview"></div>
        <template v-for="(item, index) in canvas_item_arr">
          <!-- 生成的锚点-->
          <div :key="index">
            <div class="preview">
              <div class="canvas-content">
                <div
                  :id="'canvas_' + index"
                  style="background-color: white"
                  :style="{
                    width: A_4.w + 'px',
                    height: A_4.h + 'px',
                    display: 'flex',
                    'flex-wrap': 'wrap',
                  }"
                >
                  <template v-for="pic_item in item">
                    <div
                      :key="pic_item.uuid"
                      :style="{
                        display: 'flex',
                        'flex-direction': 'column',
                        'align-items': 'center',
                        'flex-grow': 1,
                        width: qr_code_w + qr_border_width * 2 + 'px',
                      }"
                    >
                      <img
                        :src="
                          $CheckUtil.CheckEmpty(pic_item.qrcode)
                            ? pic_item.qrcode
                            : '#'
                        "
                        :width="qr_code_w"
                        :height="qr_code_h"
                      />
                      <span
                        style="text-align: center;font-weight: bold;font-size: 20px"
                      >
                        {{ pic_item.id }}
                      </span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div style="text-align: center;font-size: 15px;font-weight: bolder">
              {{ index + 1 }} / {{ totalPage }}
            </div>
            <a-divider :dashed="true" />
          </div>
        </template>
      </a-modal>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { createQrCode, getActiveMember, batchQrShareCode } from "@/api/program";
import html2canvas from "html2canvas";

export default {
  name: "Member",
  data() {
    return {
      // modal
      visible: false,
      confirmLoading: false,
      modalType: false,
      // preview modal
      preview: false,
      // form
      form: {
        table_pk: 0,
        name: "",
        code: "",
        uid: 0,
        task: 999,
        type: 0,
      },
      // table
      id: null /* 当前活动 id*/,
      tableData: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      loading: false,
      qr_code_w: 230,
      qr_code_h: 230,
      qr_border_width: 2,
      A_4: {
        w: 595,
        h: 842,
      },
      totalPage: 0,
      canvas_arr: [],
      canvas_item_arr: [],
    };
  },

  created() {
    let query = this.$route.query;
    this.id = parseInt(query.id);
    this.programMemberList();
  },
  methods: {
    /* 设置二维码宽高 */
    setQrSize: function() {
      this.qr_code_w = this.qr_code_w + this.qr_border_width * 2;
      this.qr_code_h = this.qr_code_h + this.qr_border_width * 2;
    },
    /* 下载全部二维码 准备数据阶段 */
    beforeDownload: function() {},
    /* 下载二维码 html2canvas */
    download: function() {
      for (let i = 0; i < this.canvas_item_arr.length; i++) {
        // let el = document.getElementById('canvas_' + i)
        html2canvas(document.querySelector("#canvas_" + i), {
          allowTaint: true,
        }).then((canvas) => {
          // document.getElementById('preview').appendChild(canvas)
          let base64 = canvas.toDataURL();
          let oA = document.createElement("a");
          oA.download = "活动推广二维码"; // 设置下载的文件名，默认是'下载'
          oA.href = base64;
          document.body.appendChild(oA);
          oA.click();
          oA.remove(); // 下载之后把创建的元素删除
        });
      }
    },
    cancelPreview: function() {
      // modal hidden
      this.preview = !this.preview;
    },
    /* 批量生成 二维码 */
    batchQrCode: function() {
      // 为没有二维码的生成二维码
      batchQrShareCode({
        activity_id: this.id,
      }).then((res) => {
        let text = res.msg;
        this.$message.success({
          content: text,
        });
      });
    },

    checkNum: function(value) {
      if (value > 1000) {
        this.form.task = 1000;
      } else if (value < 1) {
        this.form.task = 1;
      } else {
        this.form.task = value;
      }
    },
    // ------- table --------
    pageChange: function(page) {
      this.pagination.current = page.current;
      this.programMemberList();
    },
    /* 生成推广二维码 */
    createQr: function(record) {
      let data = {
        id: record.id,
        activity_id: this.id,
      };
      let type = record.user_type === 1 ? "员工" : "兼职";
      createQrCode(data).then((res) => {
        if (res.code === 1) {
          this.$message.success({
            content: `${type}  ${record.name} 小程序推广二维码创建成功`,
          });
        }
      });
    },
    /* modal 新增 */
    edit: function(record) {
      this.visible = this.modalType = true;

      this.form.table_pk = record.id;
      this.form.name = record.name;
      this.form.code = record.code;
      this.form.uid = record.uid;
      this.form.task = record.task;
      this.form.type = record.user_type;
    },
    add: function() {
      this.visible = true;
      this.modalType = false;
    },
    Confirm: function() {
      this.confirmLoading = true;
    },
    Cancel: function() {
      this.visible = !this.visible;

      this.form.table_pk = 0;
      this.form.name = "";
      this.form.code = "";
      this.form.uid = 0;
      this.form.task = 999;
      this.form.type = 0;
    },
    programMemberList: function() {
      getActiveMember({
        activity_id: this.id,
        page_index: this.pagination.current,
        page_size: this.pagination.pageSize,
      }).then((res) => {
        if (res["code"] === 1) {
          this.tableData = res["tableData"];
          this.pagination.total = res["total"];
        } else {
          this.$message.warning(res["msg"]);
        }
      });
    },
  },
};
</script>

<style scoped>
.preview {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.canvas-content {
  box-shadow: 3px 6px 9px rgba(0, 21, 41, 0.08);
  margin-bottom: 15px;
  margin-top: 5px;
}
</style>
